export const environment = {
  production: true,
  baseUrl: 'https://nascermulher.cloud4link.com/api',
  baseSignalRUrl: 'https://nascermulher.cloud4link.com/',
  logo: 'Logo02_1.avif',
  login: true,
  configurations: [
    {
      label: "Manage Group",
      url: "groups",
      icon: "fa-layer-group",
    },
    {
      label: "Manage Devices",
      url: "devices",
      icon: "fa-microchip",
    },
    {
      label: "Manage Plan",
      url: "rules",
      icon: "fa-file",
    },
    {
      label: "Manage Scenario",
      url: 'commands',
      icon: 'fa-code'
    },
    {
      label: "Manage Holidays",
      url: 'holiday',
      icon: 'fa-glass-cheers'
    },
    {
      label: "Configuration",
      url: 'config',
      icon: 'fa-cog'
    },
    {
      label: "See Pairs",
      url: "pairs",
      icon: "fa-code-branch",
    },
    {
      label: "Logs",
      url: "logs",
      icon: "fa-book",
    }
  ]
};
